import { useAuthState } from "react-firebase-hooks/auth";
import { useLocation } from "wouter";
import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { auth } from "../firebase";
import useAuth from '../hooks/useAuth';

export default function ProtectedRoute({ children }) {
  const [user, loading] = useAuthState(auth);
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(async () => {
    if (!loading && !user) {
      // We only allow users from itstoday.org
      // to access the dashboard.
      navigate("/")
    }
  }, [user, loading]);

  if (loading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary">a</div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
}
